import { Node } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";

import { ARTICLE_BODY_ORIGIN } from "@/grading/constants";
import KeyTermButton from "@/view/KeyTermButton";
import { useDynamicDataProvider } from "@/view/TiptapArticleBody/extensions/DataProvider";
import { ComponentProps } from "@/view/TiptapArticleBody/TiptapArticleBody.interface";

interface KeyTermOptions {
  componentOrigin: keyof typeof ARTICLE_BODY_ORIGIN;
  toggleVocabularySupport: () => void;
  keyTermDataContentId: string;
}

const Component = ({
  node,
  extension,
  editor,
}: ComponentProps<KeyTermOptions>) => {
  const { componentOrigin, toggleVocabularySupport, keyTermDataContentId } =
    extension?.options;

  const { currentFontSize: fontSize, userProperties } =
    useDynamicDataProvider(editor);
  const keyTermText = node.textContent;
  const { definition, id } = node.attrs;
  const isArticleBodyFromViewPage =
    componentOrigin === ARTICLE_BODY_ORIGIN.VIEW_PAGE;

  // Only display the key term button if the article body is from the view page
  if (isArticleBodyFromViewPage) {
    return (
      <NodeViewWrapper as="span">
        <KeyTermButton
          currentFontSize={fontSize}
          dataIdentifier={id}
          isStudent={userProperties?.isStudent}
          keyTerm={keyTermText}
          keyTermDataContentId={keyTermDataContentId}
          termDefinition={definition}
          toggleVocabularySupport={toggleVocabularySupport}
        >
          {keyTermText}
        </KeyTermButton>
      </NodeViewWrapper>
    );
  }
  return null;
};

export const KeyTerm = Node.create<KeyTermOptions>({
  name: "keyTerm_block",
  content: "text*",
  group: "inline",
  inline: true,
  addAttributes() {
    return {
      id: {},
      definition: { default: null },
    };
  },
  addOptions() {
    return {
      componentOrigin:
        ARTICLE_BODY_ORIGIN.VIEW_PAGE as keyof typeof ARTICLE_BODY_ORIGIN,
      toggleVocabularySupport: () => null,
      keyTermDataContentId: "",
    };
  },
  renderHTML() {
    return ["span", 0];
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});
